import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "email-preview-pane" }
const _hoisted_2 = { class: "font-weight-600 font-size-16" }
const _hoisted_3 = {
  key: 0,
  class: "v-divider"
}
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 1,
  class: "preview-container"
}
const _hoisted_6 = { class: "template-area" }
const _hoisted_7 = { class: "preview-frame" }
const _hoisted_8 = {
  key: 2,
  class: "default-container"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "font-weight-600 font-size-24 margin-top-40" }
const _hoisted_11 = { class: "font-weight-400 font-size-14 margin-top-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailTemplateRenderer = _resolveComponent("EmailTemplateRenderer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showPreview)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["email-header", {'no-border': _ctx.isMobile}])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["email-info-section", {'mobile-display': _ctx.isMobile}])
          }, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.sendGridTemplate.TemplateData.EmailTypeProp), 1),
            (!_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(["email-subject-ellipses font-weight-400 font-size-16", _ctx.isMobile ? 'email-subject-full' : 'email-subject-ellipses']),
              title: _ctx.sendGridTemplate.TemplateData.EmailSubject
            }, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.Subject")) + " : " + _toDisplayString(_ctx.sendGridTemplate.TemplateData.EmailSubject), 11, _hoisted_4)
          ], 2),
          (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "javascript:void(0)",
                class: "edit-email-link",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.OnEditEmailClick && _ctx.OnEditEmailClick(...args)))
              }, _toDisplayString(_ctx.$t('Invite.ConfigureEmails.EditEmailLink')), 1))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.showPreview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_EmailTemplateRenderer, { "template-data": _ctx.sendGridTemplate }, null, 8, ["template-data"])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("img", { src: _ctx.emailIcon }, null, 8, _hoisted_9),
          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.LandingPageHeading")), 1),
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.LandingPageSubHeading")), 1)
        ]))
  ]))
}